"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemWidget = exports.ActiveMenuItemSubmenuDelayMs = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var DomUtil_1 = require("../utils/DomUtil");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var Overlay_1 = require("../utils/Overlay");
var FlyoutListMenuWidget_1 = require("./FlyoutListMenuWidget");
var ListMenuWidget_1 = require("./ListMenuWidget");
exports.ActiveMenuItemSubmenuDelayMs = 150; // TFSID 707410
var SubMenuOffset = function () { return -(
// tslint:disable-next-line:max-line-length
parseFloat((FlyoutListMenuWidget_1.FlyoutListMenuStyles.borderTopWidth || FlyoutListMenuWidget_1.FlyoutListMenuStyles.borderTop || FlyoutListMenuWidget_1.FlyoutListMenuStyles.borderWidth || FlyoutListMenuWidget_1.FlyoutListMenuStyles.border || '0')) +
    parseFloat((ListMenuWidget_1.ListMenuStyles.paddingTop || ListMenuWidget_1.ListMenuStyles.padding || '0'))); };
var SubMenuAnchorOrigin = { vertical: Overlay_1.VerticalOriginOption.top, horizontal: Overlay_1.HorizontalOriginOption.right };
var SubMenuStackedOrigin = { vertical: Overlay_1.VerticalOriginOption.top, horizontal: Overlay_1.HorizontalOriginOption.left };
var MenuItemStyle = { outline: 'none' };
function shouldShowSubmenu(props, state) {
    return state.menuItemActive
        && !!props.isHighlighted
        && !props.disabled
        && !props.isUnselectable
        && !!props.menuItemInfos;
}
var MenuItemWidget = /** @class */ (function (_super) {
    tslib_1.__extends(MenuItemWidget, _super);
    function MenuItemWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.domRef = React.createRef();
        _this.subMenuDomId = DomUtil_1.generateId();
        _this.state = {
            menuItemActive: false
        };
        _this.hasSubMenu = function () {
            return !!_this.props.menuItemInfos;
        };
        _this.handleKeyDown = function (e) {
            if (_this.props.disabled) {
                return;
            }
            switch (e.key) {
                case ' ':
                case 'Enter':
                    _this.handleSelect();
                    break;
                case 'ArrowRight':
                    if (_this.hasSubMenu()) {
                        _this.handleSelect();
                    }
                    break;
                default:
                    return;
            }
            e.preventDefault();
            e.stopPropagation();
        };
        // MenuItems with submenus show immediately on button press, but only after a delay on hover
        _this.handleSelect = function () {
            if (_this.props.disabled || _this.props.isUnselectable) {
                return;
            }
            if (_this.hasSubMenu()) {
                clearTimeout(_this.showSubMenuTimeoutId);
                _this.setState({ menuItemActive: true });
            }
            else {
                _this.props.onSelect(_this.props.value);
            }
        };
        _this.handleClick = function (e) {
            e.preventDefault(); // TFS 1079434
            _this.handleSelect();
        };
        _this.handleItemMouseEnter = function (e) {
            if (_this.props.disabled || _this.props.isUnselectable) {
                return;
            }
            _this.props.onHover(_this.props.itemIndex);
            if (_this.hasSubMenu()) {
                _this.showSubMenuTimeoutId = window.setTimeout(function () { return _this.setState({ menuItemActive: true }); }, exports.ActiveMenuItemSubmenuDelayMs);
            }
        };
        _this.handleItemMouseLeave = function (e) {
            clearTimeout(_this.showSubMenuTimeoutId);
        };
        // MenuItems without submenus immediately show active styling on button press
        _this.handleActive = function (active) {
            if (_this.hasSubMenu()) {
                return;
            }
            _this.setState({ menuItemActive: active });
        };
        // submenu says mouse has entered, so notify containing menu not to dismiss if
        // pointer strayed onto the next item on the way over, TFSID 707410
        _this.handleSubmenuMouseEnter = function () {
            _this.props.onHover(_this.props.itemIndex);
        };
        _this.handleSubmenuClose = function () {
            _this.setState({ menuItemActive: false });
        };
        _this.getItemClientRect = function () {
            if (!_this.domRef.current) {
                return undefined;
            }
            var _a = _this.domRef.current.getBoundingClientRect(), height = _a.height, width = _a.width, left = _a.left, right = _a.right, top = _a.top, bottom = _a.bottom;
            return { height: height, width: width, left: left, right: right, top: top + SubMenuOffset(), bottom: bottom + SubMenuOffset() };
        };
        return _this;
    }
    MenuItemWidget.prototype.componentDidMount = function () {
        var _this = this;
        // use a timeout on initial mount as a proxy for "probably attached to document by now"
        window.setTimeout(function () { return _this.updateFocus(); });
    };
    MenuItemWidget.prototype.componentDidUpdate = function (prevProps, prevState) {
        // If the user hovers over and highlights another menu item while a sub menu is open
        if (prevProps.isHighlighted && !this.props.isHighlighted && this.state.menuItemActive) {
            this.setState({ menuItemActive: false });
        }
        if (!shouldShowSubmenu(prevProps, prevState) && shouldShowSubmenu(this.props, this.state)) {
            this.props.onSubmenuShown(this.props.itemIndex);
        }
        this.updateFocus();
    };
    MenuItemWidget.prototype.componentWillUnmount = function () {
        clearTimeout(this.showSubMenuTimeoutId);
    };
    MenuItemWidget.prototype.updateFocus = function () {
        var _a = this.props, isHighlighted = _a.isHighlighted, keyboardFocused = _a.keyboardFocused;
        // Put keyboard focus on highlighted item, but not if it has a child submenu open
        if (isHighlighted && !this.state.menuItemActive && keyboardFocused && document.body.contains(this.domRef.current)) {
            this.domRef.current.focus();
        }
    };
    MenuItemWidget.prototype.getDisplayElement = function () {
        var displayValueFormatterProps = {
            active: this.state.menuItemActive && this.props.isHighlighted,
            checked: this.props.checked,
            disabled: this.props.disabled,
            hasSubMenu: this.hasSubMenu(),
            isGroupLabel: this.props.isGroupLabel,
            isHighlighted: this.props.isHighlighted,
            showCheckGutter: this.props.showCheckGutter,
            testId: this.props.testId
        };
        return React.createElement(this.props.displayFormatterBoundWithData, displayValueFormatterProps);
    };
    MenuItemWidget.prototype.render = function () {
        var showSubmenu = shouldShowSubmenu(this.props, this.state);
        var hasSubmenu = this.hasSubMenu();
        if (this.props.isGroupLabel) {
            return this.getDisplayElement();
        }
        return React.createElement(React.Fragment, null,
            React.createElement(InteractiveDom_1.InteractiveDomWrapper, { disabled: this.props.disabled, handleActive: this.handleActive, key: 'item', pointerClick: this.handleClick },
                React.createElement("div", { "aria-checked": this.props.checked, "aria-disabled": this.props.disabled, "aria-expanded": showSubmenu ? true : (hasSubmenu ? false : undefined), "aria-haspopup": hasSubmenu ? 'menu' : undefined, "data-tb-test-id": this.props.testId + "-" + this.props.value + "-MenuItem", onKeyDown: this.handleKeyDown, onMouseEnter: this.handleItemMouseEnter, onMouseLeave: this.handleItemMouseLeave, ref: this.domRef, role: this.props.role || (this.props.checked === undefined ? 'menuitem' : 'menuitemcheckbox'), style: MenuItemStyle, tabIndex: -1 },
                    this.getDisplayElement(),
                    showSubmenu && React.createElement(FlyoutListMenuWidget_1.GenericFlyoutListMenuWidget, { allowAutoPosition: this.props.subMenuAllowAutoPosition, anchorOrigin: SubMenuAnchorOrigin, getAnchorClientRect: this.getItemClientRect, id: this.subMenuDomId, maxHeight: this.props.subMenuMaxHeight, menuItemInfos: this.props.menuItemInfos, menuStyle: this.props.subMenuStyle, onEscapeKeyUp: this.handleSubmenuClose, onLeftArrowKeyDown: this.handleSubmenuClose, onMouseEnter: this.handleSubmenuMouseEnter, onSelect: this.props.onSelect, requestCloseAll: this.props.requestCloseAll, scrollingRootId: this.props.scrollingRootId, shouldAutoPositionOnScrollingRootScroll: this.props.subMenuShouldAutoPositionOnScrollingRootScroll, stackedOrigin: SubMenuStackedOrigin, stackingRootId: this.props.stackingRootId, testId: this.props.testId + "-" + this.props.value, zIndex: this.props.zIndex }))),
            showSubmenu && React.createElement("div", { "aria-owns": this.subMenuDomId, key: 'submenu' }));
    };
    return MenuItemWidget;
}(React.PureComponent));
exports.MenuItemWidget = MenuItemWidget;
//# sourceMappingURL=MenuItemWidget.js.map